export const getOrderIdTdClass = order => {
  const classArr = ['order-id-td']
  
  if (order.delivery_expired) {
    classArr.push('delivery-expired')
  } else if (order.deadline_expired) {
    classArr.push('deadline-expired')
  }
  return classArr.join(' ')
}